<template>
  <div class="attributes-list" v-if="item">
    <div class="item-attribute attribute-owner" v-if="item.owner">
      <div class="attribute-label">Owner:</div>
      <div class="attribute-value">{{ item.owner.fullName }}</div>
    </div>
    <div class="item-attribute attribute-launched-date">
      <div class="attribute-label">Listing Date:</div>
      <div class="attribute-value">
        {{ getFormatDate(item.updatedAt) }}
      </div>
    </div>
    <div
      class="item-attribute attribute-experience-count"
      v-if="item.stats && item.stats.memberCount"
    >
      <div class="attribute-label">Members:</div>
      <div class="attribute-value">
        {{ getDecimalFormat(item.stats.memberCount) }}
      </div>
    </div>
    <div class="item-attribute attribute-fee">
      <div class="attribute-label">Fees:</div>
      <div class="attribute-value">
        {{ getFee(item.fee) }}
      </div>
    </div>
    <div class="social-identifiers" v-if="item.socialIdentifiers">
      {{ item.socialIdentifiers }}
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    item: {
      type: Object,
      default() {
        return {
          name: "",
          owner: {
            id: "",
            fullName: "",
          },
          launchedDate: "",
          type: "",
          stats: {
            experienceCount: 0,
          },
          fee: 0,
          thumbnailUrl: "",
        };
      },
    },
  },
  methods: {
    getFormatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    getReadableDateTime(date) {
      return moment(date).fromNow();
    },
    getReadableType(type) {
      switch (type) {
        case "destination":
          return "Destination Page";
        case "thematic":
          return "Thematic Page";
        case "brand":
          return "Brand Page";
        case "regional":
          return "Regional Page";
        default:
          return "Others";
      }
    },
    getDecimalFormat(number) {
      return typeof number === "number" ? number.toLocaleString("en-US") : "0";
    },
    getFee(number) {
      return number === null || number === undefined || number === 0
        ? "Free"
        : this.getDecimalFormat(number);
    },
  },
};
</script>

<style lang="scss" scoped>
.attributes-list {
  font-size: 12px;

  .item-attribute {
    display: flex;
  }
  .attribute-label {
    font-weight: bold;
    width: 100px;
    margin-right: 10px;
    flex: 0 0 auto;
  }
  .attribute-fee .attribute-value,
  .attribute-type .attribute-value {
    text-transform: uppercase;
  }

  .last-updated {
    margin-top: 20px;
  }

  .social-identifiers {
    font-size: 20px;
    font-weight: 500;
    margin: 10px 0 0;
  }
}
</style>